import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=5cd838f7&"
import script from "./feedback.vue?vue&type=script&lang=js&"
export * from "./feedback.vue?vue&type=script&lang=js&"
import style0 from "./feedback.vue?vue&type=style&index=0&id=5cd838f7&prod&lang=scss&"
import style1 from "./feedback.vue?vue&type=style&index=1&id=5cd838f7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports